import script from "./AnnounceView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnounceView.vue?vue&type=script&setup=true&lang=ts"

import "./AnnounceView.vue?vue&type=style&index=0&id=59fb5b87&scoped=true&lang=css"
import "./AnnounceView.vue?vue&type=style&index=1&id=59fb5b87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fb5b87"]])

export default __exports__